module.exports = __webpack_public_path__ + "media/app/assets/races/highmountain_tauren_female-f201738efdbea54a354952b6ffd0c7da.png";